import React from "react";
import transparentBg from "../../assets/images/transparent-background.png";

export interface ColorSwatchProps {
  /** Color value in RGBA hex format (e.g., #ff5500ff) */
  color: string;
  /** Size of the swatch in pixels */
  size?: number;
  /** Border radius in pixels */
  borderRadius?: number;
  /** Optional className */
  className?: string;
  /** Optional style overrides */
  style?: React.CSSProperties;
}

/**
 * A color swatch that displays a color with transparency background.
 * When the color has low opacity, the checkerboard pattern shows through.
 * Uses layered divs instead of combined backgroundImage to ensure
 * reliable color updates across all environments.
 */
export const ColorSwatch: React.FC<ColorSwatchProps> = ({
  color,
  size = 32,
  borderRadius = 4,
  className,
  style,
}) => {
  return (
    <div
      className={className}
      style={{
        position: "relative",
        width: size,
        height: size,
        borderRadius,
        overflow: "hidden",
        ...style,
      }}
    >
      {/* Checkerboard pattern layer (bottom) */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${transparentBg})`,
          backgroundSize: "100% 100%",
          backgroundRepeat: "repeat",
          borderRadius: "inherit",
        }}
      />
      {/* Color overlay layer (top) */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: color,
          display: "block",
          borderRadius: "inherit",
        }}
      />
    </div>
  );
};
